import type { Drama } from "@/types/drama";

interface EpisodeListProps {
  drama: Drama;
  onSelect: (index: number) => void;
}

export default function EpisodeList({ drama, onSelect }: EpisodeListProps) {
  const episodes = Array.from({ length: Math.min(drama.totalEpisodes, 60) }, (_, index) => index + 1);

  return (
    <section aria-labelledby="episode-title" className="rounded-lg border border-background-200 bg-background-50">
      <div className="flex flex-wrap items-center justify-between gap-2 border-b border-background-200 px-4 py-3 md:px-5">
        <h2 id="episode-title" className="font-heading text-base font-bold text-foreground-950 md:text-lg">
          剧集列表
        </h2>
        <p className="text-[11px] text-foreground-500 md:text-xs">
          共 {drama.totalEpisodes} 集 · 已更新 {drama.updatedEpisodes} 集
        </p>
      </div>

      <div className="px-4 py-4 md:px-5">
        <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide md:grid md:grid-cols-8 md:gap-2 md:overflow-visible md:pb-0">
          {episodes.map((episode) => {
            const isNew = episode > drama.updatedEpisodes;
            return (
              <button
                key={episode}
                type="button"
                onClick={() => onSelect(episode)}
                className={`group flex w-[64px] shrink-0 cursor-pointer flex-col items-center justify-center rounded-md border px-2 py-2.5 text-xs transition-colors md:w-auto ${
                  isNew
                    ? "border-background-200 bg-background-100 text-foreground-400 hover:border-primary-300 hover:text-primary-600"
                    : "border-background-300 bg-background-50 text-foreground-800 hover:border-primary-400 hover:bg-primary-50 hover:text-primary-700"
                }`}
                aria-label={`播放第 ${episode} 集`}
              >
                <span className="font-medium">{episode}</span>
                <span className="mt-0.5 text-[10px] text-foreground-400">
                  {isNew ? "预告" : "播放"}
                </span>
              </button>
            );
          })}
        </div>
        <p className="mt-3 flex items-start gap-1.5 text-[11px] leading-relaxed text-foreground-500">
          <i className="ri-information-line mt-0.5 text-sm text-accent-600" aria-hidden="true" />
          点击任意集数会弹出播放器演示提示，本站不接入真实视频源，仅供功能演示。
        </p>
      </div>
    </section>
  );
}